import { render, staticRenderFns } from "./ListConfigCards.vue?vue&type=template&id=3052a36b"
import script from "./ListConfigCards.vue?vue&type=script&lang=js"
export * from "./ListConfigCards.vue?vue&type=script&lang=js"
import style0 from "./ListConfigCards.vue?vue&type=style&index=0&id=3052a36b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports